import script from "./ExercisePrimGraph.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExercisePrimGraph.vue?vue&type=script&setup=true&lang=ts"

import "./ExercisePrimGraph.vue?vue&type=style&index=0&id=8f1c6520&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f1c6520"]])

export default __exports__